module.exports = __webpack_public_path__ + "static/media/transaction-error-icon-red.7e65d8e5.svg";